/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PublishBotExamShowViewModel } from "../types/PublishBotExamShowViewModel.ts";
import { dropDownListViewModelSchema } from "./dropDownListViewModelSchema.ts";

export const publishBotExamShowViewModelSchema = z.object({
  botExamId: z.optional(z.number().int().describe("ID da prova bot.")),
  startDate: z
    .string()
    .datetime()
    .describe("Data de início da publicação da prova bot. Opcional.")
    .nullish(),
  endDate: z
    .string()
    .datetime()
    .describe("Data de término da publicação da prova bot. Opcional.")
    .nullish(),
  title: z.string().describe("Título da prova bot. Opcional.").nullish(),
  teachersList: z
    .array(z.lazy(() => dropDownListViewModelSchema))
    .describe(
      "Lista de professores disponíveis para vinculação à prova bot (key = ID, value = nome).",
    )
    .nullish(),
}) as unknown as ToZod<PublishBotExamShowViewModel>;
